module.exports = __webpack_public_path__ + "static/media/drugTreatment.341d9f0c.svg";